import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Awards } from '../../shared/models/Awards';
import { DatePipe } from '@angular/common';
import { EmployeeService } from '../../shared/service/employee.service';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import { FormGroup, FormControl } from '@angular/forms';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { isNullOrUndefined } from 'util';

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'DD-MMM-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'app-hr-awards',
  templateUrl: './hr-awards.component.html',
  styleUrls: ['./hr-awards.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class HrAwardsComponent implements OnInit {
  award: Awards;
  date: Date;
  datePipe: DatePipe;
  frequency: any;
  empList: any[];
  error: string;
  pickerDate: any;
  todayDate: Date;
  AwardForm: FormGroup;
  awards: any;
  LoginEmpCode: any;
  toastr: any;
  changeTab: any;
  AwardDetails: any;
  @Input() EmpId: number;
  @Input() empCode: number;
  @Output('awardDetValue') awardDetValue = new EventEmitter();
  awardDetails: any[] = [];
  FinancialYears: any[];
  NominatedBy: any;
  filteredList: any;
  originalAward: any;
  constructor(private emp_Svc: EmployeeService) {
    this.date = new Date();
    this.todayDate = new Date();
  }

  ngOnInit() {
    this.award = new Awards();
    this.getEmployeeList();
    //    this.GetEmployeeAwardDetails();
    this.FormInitialization();
    this.loadFinancialYears();
    this.originalAward = JSON.parse(JSON.stringify(this.award))
  }
  schemeChange(event) {
    alert(event);
    //let text = event.target.options[event.target.options.selectedIndex].text;
    this.award.Frequency = event;
  }
  FormInitialization() {
    this.awardDetValue.emit(this.award);
    this.AwardForm = new FormGroup({
      FinancialYear: new FormControl(),
      Frequency: new FormControl(),
      Quarter: new FormControl(),
      Annual: new FormControl(),
      Adhoc: new FormControl(),
      Q1: new FormControl(),
      Q2: new FormControl(),
      Q3: new FormControl(),
      Q4: new FormControl(),
      Award: new FormControl(),
      NominatedBy: new FormControl(),
      GiftPrice: new FormControl(),
      Comments: new FormControl(),
    });
  }
  getEmployeeList() {
    this.emp_Svc.getAllEmployees().subscribe((data: any[]) => {
      this.empList = data;
      this.filteredList = this.empList;
      //console.log(this.empList);
    }, error => this.error = error);
  }
  /*GetEmployeeAwardDetails() {
    //  alert(this.EmpId);
    this.award.EmpCode = this.empCode;
    this.awardDetails = [];
    this.emp_Svc.getEmployeeAwardDetails(this.empCode).subscribe((data: any) => {
      console.log(data);
      if (data != null && data.length != 0) {
        this.awardDetails = data;
        console.log(this.awardDetails);
      }
      else {
        this.addFieldValue();
      }
      this.awardDetValue.emit(this.awardDetails);
    }, error => this.error = error)
  }*/
  loadFinancialYears() {
    this.FinancialYears = [];
    var now = new Date();
    var mm = now.getMonth() + 1;
    var currentYear;
    var year;
    currentYear = now.getFullYear();
    year = now.getFullYear().toString().substr(2, 2);

    for (var i = 2017; i <= currentYear; i++) {


      this.FinancialYears.push({ FinancialYearId: i.toString().substr(2, 2), FinancialYear: i + '-' + (i + 1).toString().substr(2, 2) });

    }
    if (3 < mm) {
      currentYear = now.getFullYear();
      year = now.getFullYear().toString().substr(2, 2);
    }
    else {
      currentYear = now.getFullYear() - 1;
      year = (now.getFullYear() - 1).toString().substr(2, 2);
    }
    this.award.FinancialYear = (currentYear) + '-' + (parseInt(year) + (1));
    // console.log(this.FinancialYears);
  }
  //onSelectionChanged(event) {
  //  for (var i = 0; i < this.empList.length; i++) {
  //    var id = event.option.value.split("-");
  //    this.empList[i].FirstName = id[0];
  //  }
  //  console.log(event);
  //}
  doFilter() {
    if (!isNullOrUndefined(this.NominatedBy)) {
      this.filteredList = this.filter(this.empList);
    }
  }
  filter(values) {
    return values.filter(value => value.FirstName.toLowerCase().includes(this.NominatedBy.toLowerCase()))
  }

  getAwards() {
    return this.award;
  }

  getObjectState() {
    const originalAward = this.originalAward
    const currentAward = this.award;
    var awardVal = JSON.stringify(originalAward) === JSON.stringify(currentAward)
    return !(awardVal);
  }

  changeEmpCode(event) {
    for (var i = 0; i < this.empList.length; i++) {
      var id = event.option.value.split("-");
      this.empList[i].EmpCode = id[0];

    }
    //console.log(event);
  }
}
